import React from 'react';
import ReactDOM from 'react-dom';

import { CDN_ASSETS_URL } from 'constants/global';

import { ModalVideoPlayer } from 'components/ModalVideoPlayer';

type Props = {
  videoId: string;
  videoTitle: string;
  videoUrl: string;
  videoThumbnail: string;
  buttonText: string;
};

export const VideoHero: React.FC<Props> = ({
  videoUrl,
  videoThumbnail,
  buttonText,
  videoId,
  videoTitle,
}) => {
  const playVideo = () => {
    const placeholder = $('<div />').appendTo($('body'));
    ReactDOM.render(
      <ModalVideoPlayer type={'vimeo'} videoId={videoId} title={videoTitle} />,
      placeholder[0],
    );
  };
  return (
    <div className='page-hero page-hero--viewport page-hero--inverse pos-rel'>
      <div className='stretch overflow-hidden'>
        <video preload='true' loop autoPlay muted>
          <source src={`${CDN_ASSETS_URL}${videoUrl}`} type='video/mp4' />
          <source
            className='lazy-background'
            src={`${CDN_ASSETS_URL}${videoThumbnail}`}
            type='video/mp4'
          />
        </video>
      </div>
      <div className='absolute-overlay absolute-overlay--medium-dark'></div>
      <button
        onClick={playVideo}
        className='pos-rel btn--unstyled d-flex align-items-center text-left'
      >
        <div className='player__btn player__btn--large player__btn--icon icon-play'></div>
        <div className='key-value key-value--lg ml-1 lh-tight key-value__value'>{buttonText}</div>
      </button>
    </div>
  );
};
